import React from 'react';
import { Modal, Button } from 'tea-component';
import './index.scss';

interface AutoSaveModalProps {
  visible: boolean;
  onConfirm?: Function | null;
  onClose?: Function | null;
}

const AutoSaveModal: React.FC<AutoSaveModalProps> = (props) => {
  const { visible = false, onConfirm, onClose } = props;
  const handleOnChangeOk = () => {
    onConfirm?.();
  };
  const handleOnChangeCancel = () => {
    onClose?.();
  };

  return (
    <Modal
      className={'dbs-common-modal'}
      visible={visible}
      size={'m'}
      onClose={handleOnChangeCancel}
    >
      <Modal.Body className="dbs-autosave-modal-body">
        <div className="dbs-autosave-modal-title">Recover Previous Session?</div>
        <div className="dbs-autosave-modal-content">
          <div className="dbs-autosave-modal-text">An autosave is available from your last session.</div>
          <div className="dbs-autosave-modal-text">Do you want to restore it or discard it?</div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={handleOnChangeOk}>
          Restore
        </Button>
        <Button type="weak" onClick={handleOnChangeCancel}>
          Discard
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(AutoSaveModal);
